import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class WorkPositionImporter  {
    _originalTypeClassName = "zERP.BO.WorkPositionImporter";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
WorkPositionImporter.translate = translateService;
}
this.info = null;
this.WorkPositionImporterKey = null;
this._key = this.WorkPositionImporterKey = 0; 
}

static translate: TranslateService;
_key: any;
info:any;
private _WorkPositionImporterKey:any;
get WorkPositionImporterKey(): any {
    return this._WorkPositionImporterKey;
  }
set WorkPositionImporterKey(value: any) {
    this._WorkPositionImporterKey = value;
    this._key = value;
  }

static ParseIsActive(active: any): any{return ((active == "ΝΑΙ" || active == "NAI") ? true : false);
}
static ParsePlacement(el: any): any{return (el == "Οργανική" ? Domain.Placement.Organic : ((el == "Προσωρινή" ? Domain.Placement.Temporary : Domain.Placement.AdPersonam)));
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.WorkPositionImporterKey == null || $this.WorkPositionImporterKey == 0;
            }


}